<template>
  <div class="profile-property__input-inner">
    <el-autocomplete
      v-model="display"
      :fetch-suggestions="getSuggestions"
      placeholder="Город"
      class="profile-property__input address"
      @select="selectCity"
      :class="{'input__error': !isValid}"/>
  </div>
</template>

<script>
  import Parent from './Parent'
  import debounce from 'lodash/debounce'
  import axios from 'axios'
  import map from 'lodash/map'

  export default {
    name: 'Location',
    mixins: [Parent],
    data: function () {
      return {
        display: '',
        minLength: 2
      }
    },
    created: async function () {
      const response = await axios.get(`/getLocationByCode?code=${this.val}`)
      this.display = response.data.location
    },
    methods: {
      getSuggestions: debounce(async function (queryString, cb) {
        if (queryString.length < this.minLength) {
          cb([])
          return
        }
        const response = await axios.post('/order/getCitySuggestion', {
          query: queryString
        })
        cb(map(response.data, e => {
          return {
            value: e.DISPLAY,
            id: e.ID,
            code: e.CODE
          }
        }))
      }, 500).bind(this),
      selectCity: function ({code, value}) {
        this.val = code
        this.display = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/Inputs/Location.vue